<template>
    <!-- ---------------------------------- 常见问题 ---------------------------------- -->
    <div class="problem">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 标题 ---------------------------------- -->
        <div class="problem_title">
            <p>常见问题</p>
        </div>
        <!-- ---------------------------------- 问题 ---------------------------------- -->
        <div class="problem_main">
            <!-- 标题 -->
            <div class="main_box">
                <!-- 蓝色图标 -->
                <div class="blue_icon">Q</div>
                <!-- 文字 -->
                <div class="blue_text">
                    是否可以订购自定义服务计划或服务周期?
                </div>
            </div>
            <!-- 内容 -->
            <div class="main_box">
                <!-- 粉色图标 -->
                <div class="pink_icon">A</div>
                <!-- 文字 -->
                <div class="pink_text">
                    我们有不同的服务计划可以满足您的需求。欢迎联系我们的服务热线来咨询,
                    请致电400 920
                    3910或通过电子邮件发送到<a href="mailto:support@renaudchina.com">support@renaudchina.com</a>.
                </div>
            </div>
        </div>
        <div class="problem_main">
            <!-- 标题 -->
            <div class="main_box">
                <!-- 蓝色图标 -->
                <div class="blue_icon">Q</div>
                <!-- 文字 -->
                <div class="blue_text">
                    如果我订购你们的服务，我需要支付送货费吗？
                </div>
            </div>
            <!-- 内容 -->
            <div class="main_box">
                <!-- 粉色图标 -->
                <div class="pink_icon">A</div>
                <!-- 文字 -->
                <div class="pink_text">
                    免费送货！我们可以在交货期间帮您安装滤网和设置机器.
                </div>
            </div>
        </div>
        <div class="problem_main">
            <!-- 标题 -->
            <div class="main_box">
                <!-- 蓝色图标 -->
                <div class="blue_icon">Q</div>
                <!-- 文字 -->
                <div class="blue_text">你们接受哪些付款方式?</div>
            </div>
            <!-- 内容 -->
            <div class="main_box">
                <!-- 粉色图标 -->
                <div class="pink_icon">A</div>
                <!-- 文字 -->
                <div class="pink_text">
                    目前, 您可以使用微信、支付宝、本地借记卡(Unionpay 银联)
                    和国际信用卡 (Visa / Mastercard 万事达卡 / American Express
                    美国运通) 支付费用.
                </div>
            </div>
        </div>
        <div class="problem_main">
            <!-- 标题 -->
            <div class="main_box">
                <!-- 蓝色图标 -->
                <div class="blue_icon">Q</div>
                <!-- 文字 -->
                <div class="blue_text">空气净化器应该每天运行几个小时?</div>
            </div>
            <!-- 内容 -->
            <div class="main_box">
                <!-- 粉色图标 -->
                <div class="pink_icon">A</div>
                <!-- 文字 -->
                <div class="pink_text">
                    建议您全天运行空气净化器，尤其是当室外空气污染严重或您患有过敏或其他呼吸道疾病时.
                </div>
            </div>
        </div>
        <div class="problem_main">
            <!-- 标题 -->
            <div class="main_box">
                <!-- 蓝色图标 -->
                <div class="blue_icon">Q</div>
                <!-- 文字 -->
                <div class="blue_text">空气净化器耗电吗?</div>
            </div>
            <!-- 内容 -->
            <div class="main_box">
                <!-- 粉色图标 -->
                <div class="pink_icon">A</div>
                <!-- 文字 -->
                <div class="pink_text">
                    很多人认为，如果一台空气净化器每天24小时运行，它会消耗大量电力。相反，现在市场上的大多数空气净化器都是节能型的，包括我们所有型号.
                </div>
            </div>
        </div>
        <div class="problem_main">
            <!-- 标题 -->
            <div class="main_box">
                <!-- 蓝色图标 -->
                <div class="blue_icon">Q</div>
                <!-- 文字 -->
                <div class="blue_text">我需要多久更换一次空气净化器的滤网?</div>
            </div>
            <!-- 内容 -->
            <div class="main_box">
                <!-- 粉色图标 -->
                <div class="pink_icon">A</div>
                <!-- 文字 -->
                <div class="pink_text">
                    滤网的使用寿命通常为6个月，因此建议每半年更换一次。及时更换滤网将延长设备的使用寿命并保持设备的空气净化效率.
                </div>
            </div>
        </div>
        <div class="problem_main" style="margin-bottom: 150px">
            <!-- 标题 -->
            <div class="main_box">
                <!-- 蓝色图标 -->
                <div class="blue_icon">Q</div>
                <!-- 文字 -->
                <div class="blue_text">
                    我的空气净化器的更换滤网和其他配件在中国大陆的所有城市都有吗?
                </div>
            </div>
            <!-- 内容 -->
            <div class="main_box">
                <!-- 粉色图标 -->
                <div class="pink_icon">A</div>
                <!-- 文字 -->
                <div class="pink_text">
                    我们在中国大陆的所有大城市都有分销商。请填写咨询表单，收到后在24小时内我们的当地分销商会与您联系.
                </div>
            </div>
        </div>
        <!-- ---------------------------------- 底部栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
export default {
    components: {
        Header,
        Footer,
    },
};
</script>

<style lang="less" scoped>
/* ------------------------------ 标题 ----------------------------- */
.problem_title {
    width: 100%;
    height: 142px;
    background: url(../assets/images/problem-bg.png) no-repeat;
    background-size: 100% 100%;
    background-position: center;
    p {
        font-size: 40px;
        font-weight: bold;
        color: #ffffff;
        letter-spacing: 15px;
        margin: 0;
        text-align: center;
        padding-top: 1.8%;
    }
}
/* ------------------------------ 问题 ----------------------------- */
.problem_main {
    width: 70%;
    margin: 0 auto;
    padding-top: 70px;
    .main_box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        // 蓝色图标
        .blue_icon {
            width: 116px;
            height: 116px;
            background-color: #d4edfc;
            border-radius: 100px 100px 0 100px;
            font-size: 50px;
            color: #009ee3;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        // 标题
        .blue_text {
            font-weight: bold;
            font-size: 33px;
            color: #284b70;
            letter-spacing: 5px;
            line-height: 116px;
            width: 88%;
            font-family: 'Microsoft YaHei';
        }
        // 粉色图标
        .pink_icon {
            width: 116px;
            height: 116px;
            background-color: #f9d9ea;
            border-radius: 100px 0 100px 100px;
            font-size: 50px;
            color: #ee859f;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        // 内容
        .pink_text {
            font-size: 30px;
            color: #284b70;
            letter-spacing: 5px;
            line-height: 1.5;
            width: 88%;
            font-family: 'Microsoft YaHei';
        }
    }
}

// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    .problem_title {
        width: 100%;
        height: 250px;
        background: url(../assets/images/problem-bg.png) no-repeat;
        background-size: 100% 100%;
        background-position: center;
        p {
            font-size: 80px;
            font-weight: bold;
            color: #ffffff;
            letter-spacing: 15px;
            margin: 0;
            text-align: center;
            // padding-top: 1.8%;
            line-height: 150px;
        }
    }
    // 标题
    .blue_text {
        font-size: 68px !important;
    }
    // 内容
    .pink_text {
        font-size: 60px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/faq.vue